<template>
    <div>
        <v-alert
            v-if="alert.show"
            type="error"
        >
            <pre style="font-family: inherit">{{ alert.message }}</pre>
        </v-alert>
        <div class="my-3">Username: <span class="font-weight-black">{{ $page.props.user.username }}</span></div>
        <v-form @submit.prevent="submitForm">
            <v-row>
                <v-col>
                    <v-text-field
                        label="Password"
                        variant="underlined"
                        color="primary"
                        type="password"
                        v-model="form.password"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-text-field
                        label="Confirm Password"
                        variant="underlined"
                        color="primary"
                        type="password"
                        v-model="form.password_confirmation"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn
                        type="submit"
                        color="primary"
                        block
                    >
                        Reset Password
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "PasswordResetForm",
    props: ['user', 'token'],
    data() {
        return {
            form: {
                token: this.$page.props.token,
                password: null,
                password_confirmation: null,
            },
            alert: {
                show: false,
                message: null,
            }
        }
    },
    methods: {
        submitForm() {
            this.alert.show = false
            this.alert.message = ''
            axios.post(route('api.reset-password'), this.form)
                .then(() => {
                    this.$emit('password-reset-success', 'Your password has successfully been reset.')
                })
                .catch((object) => {
                    if (object.response.status === 422) {
                        const errors = object.response.data.errors
                        Object.keys(errors).forEach(key => {
                            this.alert.message += `${errors[key][0]}\n`
                        })
                        this.alert.show = true
                    }
                    if (object.response.status === 400) {
                        this.alert.message = object.response.data.message
                        this.alert.show = true
                    }
                })
        }
    }
}
</script>

<style scoped>

</style>
